/**
 * PaymentReleaseFour analytics helpers.
 *
 * Purpose:
 * - Normalize payment method strings for prop55/actionInfo.
 */

const CREDIT_CARD_TYPES = new Map([
    ['sephora', 'sephoracard'],
    ['plcc', 'sephoracard'],
    ['visa', 'visa'],
    ['mastercard', 'mastercard'],
    ['americanexpress', 'americanexpress'],
    ['cbvi', 'sephoravisacard'],
    ['discover', 'discover']
]);

const toKey = raw =>
    String(raw || '')
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '');

export const normalizeCardTypeForAnalytics = cardType => {
    const rawType = String(cardType || '').toLowerCase();
    const key = toKey(rawType);

    return CREDIT_CARD_TYPES.get(key) || rawType.replace(/_/g, ' ');
};
